import React, { useState, useEffect } from "react";
import "./PerfilAluno.css";
import { buscarperfil, infomacesToken, atualizarAvatar } from "../../services/api";
import { favoritarLivro } from "../../services/api.js";
import AvatarPerfil from "../../Componets/AvatarPerfil";
import InputProgresso from "../../Componets/InputProgresso";
import MeuRanking from "../../Componets/MeuRanking";
import LivrosFavoritos from "../../Componets/LivrosFavoritos";
import Medalha from "../../Componets/Medalha";
import Icone from "../../modais/Icone";
import avatar1 from "../../imagem/perfil/avatar1.svg";
import avatar2 from "../../imagem/perfil/avatar2.svg";
import avatar3 from "../../imagem/perfil/avatar3.svg";
import avatar4 from "../../imagem/perfil/avatar4.svg";
import avatar5 from "../../imagem/perfil/avatar5.svg";
import avatar6 from "../../imagem/perfil/avatar6.svg";
import avatar7 from "../../imagem/perfil/avatar7.svg";
import avatar8 from "../../imagem/perfil/avatar8.svg";
import avatar9 from "../../imagem/perfil/avatar9.svg";
import avatar10 from "../../imagem/perfil/avatar10.svg";
import avatar11 from "../../imagem/perfil/avatar11.svg";
import avatar12 from "../../imagem/perfil/avatar12.svg";

function PerfilAluno() {
  const [mostrarModal, setMostrarModal] = useState(false);
  const [usuarioAtual, setUsuarioAtual] = useState({});

  const imagens = {avatar1, avatar2, avatar3, avatar4, avatar5, avatar6, avatar7, avatar8, avatar9, avatar10, avatar11, avatar12};

  useEffect(() => {
    carregarDados();
  }, []);

  async function carregarDados() {
    const usuario = await infomacesToken();
    if (!usuario) return;
  
    const idAluno = usuario.id_pessoa;
    try {
      const res = await buscarperfil(idAluno)
      setUsuarioAtual((prev) => ({ ...prev, ...res.data }))
    } catch (error) {
      console.log("Erro ao carregar dados do perfil: ", error);
    }
  } 
  
  
  const imagemPerfil = imagens[usuarioAtual.avatar];


  const handleTrocarImagem = async (novoAvatar) => {
    const dados = {
      idAluno: usuarioAtual.idAluno,
      idEscola: usuarioAtual.idEscola,
      novoAvatar: novoAvatar
    }

    try {
      await atualizarAvatar(dados);
      carregarDados();
    } catch (error) {
      console.log("Erro ao alterar avatar: ", error);
    }
  };

  const handleFavoritar = async (idLivro) => {
    try {
      await favoritarLivro(idLivro);
      carregarDados();
    } catch (error) {
      console.log("Erro ao favoritar livro:", error);
    }
  };

  return (
    <div className="perfil-container">
      <div className="perfil-esquerda">
        {usuarioAtual && (
          <div style={{padding: 30}}>
            <AvatarPerfil
              avatar={imagemPerfil}
              aoClicarEditar={() => setMostrarModal(true)} 
              className="avatar-perfil"
            />
            <h2>{usuarioAtual.nome}</h2>
            <InputProgresso xp={usuarioAtual.pontuacao} className="progresso-XP" />
            <MeuRanking lugar={usuarioAtual.lugarNoRanking} pontuacao={usuarioAtual.pontuacao} avatar={imagemPerfil} nome={usuarioAtual.nome}/>
          </div>
        )}
      </div>
      <div className="perfil-direita">
        <div className="perfil-titulo">
        <h1>Minha página</h1>
        </div>
         <section className="favoritos">
          <h2>Meus livros favoritos</h2>
          <LivrosFavoritos livros={usuarioAtual.livrosFavoritos} favoritar={handleFavoritar} carregarDados={() => carregarDados()} />
        </section>

        <section className="medalhas">
          <h2>Minhas medalhas</h2>
          <Medalha medalhas={usuarioAtual.medalhas} />
        </section>
      </div>
      {mostrarModal && (
        <Icone
          open={mostrarModal}
          onClose={() => setMostrarModal(false)}
          onSelecionar={handleTrocarImagem}
          avatar={imagemPerfil}
        />
      )}
    </div>
  );
}

export default PerfilAluno;